import React from "react";

const ProductCardsSkeleton: React.FC = () => {
  const skeletonItems = Array(2).fill(0); // Adjust the number of skeleton items as needed

  return (
    <fieldset>
      <div className="mt-6 grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-4">
        {skeletonItems.map((_, index) => (
          <div
            key={index}
            className="group relative flex cursor-pointer rounded-lg border border-gray-300 bg-white p-4 shadow-sm"
          >
            <span className="flex flex-1 animate-pulse">
              <span className="flex flex-col w-full">
                <span className="block h-6 w-3/4 bg-gray-200 rounded"></span>
                <span className="mt-1 h-4 w-1/2 bg-gray-200 rounded"></span>
                <span className="mt-6 h-4 w-full bg-gray-200 rounded"></span>
                <span className="mt-1 h-4 w-full bg-gray-200 rounded"></span>
                <span className="mt-6 h-4 w-1/4 bg-gray-200 rounded"></span>
              </span>
            </span>
            <span
              aria-hidden="true"
              className="pointer-events-none absolute -inset-px rounded-lg border-2 border-transparent"
            />
          </div>
        ))}
      </div>
    </fieldset>
  );
};

export default ProductCardsSkeleton;
